import { useRouteMatch } from 'react-router';
import { CvrAutoRenewalCheckoutTreatments, useFeature } from 'src/abTesting';
import { CVR_AUTO_RENEWAL_CHECKOUT } from 'src/abTesting/features';
import { useAgentMode } from 'src/pages/Signup/hooks/useAgentMode';
import { isDiySignup } from '@farmersdog/lead-browser-storage';
import { PATH_SIGNUP_CHECKOUT } from '@farmersdog/constants/paths';

interface UseAutoRenewalConsentInterstitialReturn {
  isInAutoRenewalConsentExperiment: true;
  shouldShowAutoRenewalInterstitial: true;
  shouldShowAutoRenewalCheckbox: false;
}

interface UseAutoRenewalConsentCheckboxReturn {
  isInAutoRenewalConsentExperiment: true;
  shouldShowAutoRenewalInterstitial: false;
  shouldShowAutoRenewalCheckbox: true;
}

interface UseAutoRenewalConsentOffReturn {
  isInAutoRenewalConsentExperiment: false;
  shouldShowAutoRenewalInterstitial: false;
  shouldShowAutoRenewalCheckbox: false;
}

type UseAutoRenewalConsentExperimentReturn =
  | UseAutoRenewalConsentInterstitialReturn
  | UseAutoRenewalConsentCheckboxReturn
  | UseAutoRenewalConsentOffReturn;

export function useAutoRenewalConsentExperiment(): UseAutoRenewalConsentExperimentReturn {
  const { isAgentMode } = useAgentMode();
  const isDiy = isDiySignup();
  const isOnCheckoutPage = Boolean(useRouteMatch(PATH_SIGNUP_CHECKOUT));

  const { treatment } = useFeature<CvrAutoRenewalCheckoutTreatments>(
    CVR_AUTO_RENEWAL_CHECKOUT,
    {
      attributes: { isAgentMode, isDiy, isOnCheckoutPage },
    }
  );

  if (treatment === CvrAutoRenewalCheckoutTreatments.Interstitial) {
    return {
      isInAutoRenewalConsentExperiment: true,
      shouldShowAutoRenewalInterstitial: true,
      shouldShowAutoRenewalCheckbox: false,
    };
  }

  if (treatment === CvrAutoRenewalCheckoutTreatments.Checkbox) {
    return {
      isInAutoRenewalConsentExperiment: true,
      shouldShowAutoRenewalInterstitial: false,
      shouldShowAutoRenewalCheckbox: true,
    };
  }

  return {
    isInAutoRenewalConsentExperiment: false,
    shouldShowAutoRenewalInterstitial: false,
    shouldShowAutoRenewalCheckbox: false,
  };
}
